export const Types = {
  FAVORITOS_LOADING: "FAVORITOS_LOADING",
  FAVORITOS_GET_REQUEST: "FAVORITOS_GET_REQUEST",
  FAVORITOS_GET_SUCCEEDED: "FAVORITOS_GET_SUCCEEDED",
  FAVORITOS_GET_ERROR: "FAVORITOS_GET_ERROR",

  FAVORITOS_AGREGAR_REQUEST: "FAVORITOS_AGREGAR_REQUEST",
  FAVORITOS_AGREGAR_SUCCEEDED: "FAVORITOS_AGREGAR_SUCCEEDED",
  FAVORITOS_AGREGAR_ERROR: "FAVORITOS_AGREGAR_ERROR",

  FAVORITOS_ELIMINAR_REQUEST: "FAVORITOS_ELIMINAR_REQUEST",
  FAVORITOS_ELIMINAR_SUCCEEDED: "FAVORITOS_ELIMINAR_SUCCEEDED",
  FAVORITOS_ELIMINAR_ERROR: "FAVORITOS_ELIMINAR_ERROR",

  FAVORITOS_ES_FAVORITO_REQUEST: "FAVORITOS_ES_FAVORITO_REQUEST",
  FAVORITOS_ES_FAVORITO_SUCCEEDED: "FAVORITOS_ES_FAVORITO_SUCCEEDED",
  FAVORITOS_ES_FAVORITO_ERROR: "FAVORITOS_ES_FAVORITO_ERROR",
};

export const startLoading = () => ({ type: Types.FAVORITOS_LOADING });

export const getFavoritos = (clienteId, contactoId) => ({
  type: Types.FAVORITOS_GET_REQUEST,
  clienteId,
  contactoId,
});
export const getFavoritosSucceeded = (productosFavoritos) => ({
  type: Types.FAVORITOS_GET_SUCCEEDED,
  productosFavoritos,
});
export const getFavoritosError = (err) => ({
  type: Types.FAVORITOS_GET_ERROR,
  err,
});

export const postAgregarFavoritos = (request) => ({
  type: Types.FAVORITOS_AGREGAR_REQUEST,
  request,
});
export const postAgregarFavoritosSucceeded = () => ({
  type: Types.FAVORITOS_AGREGAR_SUCCEEDED,
});
export const postAgregarFavoritosError = (err) => ({
  type: Types.FAVORITOS_AGREGAR_ERROR,
  err,
});

export const postEliminarFavoritos = (request) => ({
  type: Types.FAVORITOS_ELIMINAR_REQUEST,
  request,
});
export const postEliminarFavoritosSucceeded = () => ({
  type: Types.FAVORITOS_ELIMINAR_SUCCEEDED,
});
export const postEliminarFavoritosError = (err) => ({
  type: Types.FAVORITOS_ELIMINAR_ERROR,
  err,
});

export const getEsFavorito = (clienteId, contactoId, productoId) => ({
  type: Types.FAVORITOS_ES_FAVORITO_REQUEST,
  clienteId,
  contactoId,
  productoId,
});
export const getEsFavoritoSucceeded = (esFavorito) => ({
  type: Types.FAVORITOS_ES_FAVORITO_SUCCEEDED,
  esFavorito,
});
export const getEsFavoritoError = (err) => ({
  type: Types.FAVORITOS_ES_FAVORITO_ERROR,
  err,
});
